import { makeStyles } from '@material-ui/core/styles';

const useBlueIconHeaderStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.primary.main
  }
}));

export default useBlueIconHeaderStyles;
